// Hosts whose responses Chromium's Opaque Response Blocking (ORB) rejects
// when loaded as cross-origin <img> tags from localhost. We route those
// through our own /api/img endpoint, which streams the bytes back with
// sanitized headers. Other hosts pass through untouched to avoid the extra
// hop and keep image caching on the upstream CDN.
//
// Confirmed via the network panel: extra-leker.no returns image/png with
// nosniff for .jpg URLs and Chrome blocks every load with
// net::ERR_BLOCKED_BY_ORB. The other registered stores load fine.
const PROXY_HOSTS = new Set(["extra-leker.no", "www.extra-leker.no"]);

export function proxiedImageUrl(url: string | null | undefined): string | null {
	if (!url) return null;
	try {
		const u = new URL(url);
		if (PROXY_HOSTS.has(u.hostname)) {
			return `/api/img?u=${encodeURIComponent(url)}`;
		}
	} catch {
		return url ?? null;
	}
	return url;
}
